import { api } from "./client";
import type {
  EmailTemplateDraftResult,
  EmailTemplateEditor,
  EmailTemplateGroup,
  EmailTemplatePreview,
  EmailTemplatePreviewBlockInput,
  PublishEmailTemplateRequest,
  SaveEmailTemplateDraftRequest,
} from "@/types/emailTemplates";

// Admin "Email Templates" transport. Read the in-code catalog overlaid with the
// override store, draft, publish, roll back, reset, and preview.
// (No React Query here — that lives in hooks/emailTemplates.)
//
// Template keys are `module.email-name`, so they carry a dot; block keys are
// always the BASE key (the `:text` variant rides the request body, never the URL).
export const emailTemplatesApi = {
  list: () => api.get<EmailTemplateGroup[]>("/admin/email-templates"),

  get: (key: string) =>
    api.get<EmailTemplateEditor>(`/admin/email-templates/${encodeURIComponent(key)}`),

  saveDraft: (key: string, blockKey: string, body: SaveEmailTemplateDraftRequest) =>
    api.put<EmailTemplateDraftResult>(
      `/admin/email-templates/${encodeURIComponent(key)}/blocks/${encodeURIComponent(blockKey)}`,
      body,
    ),

  publish: (key: string, body: PublishEmailTemplateRequest) =>
    api.post<EmailTemplateEditor>(
      `/admin/email-templates/${encodeURIComponent(key)}/publish`,
      body,
    ),

  restore: (key: string, versionNumber: number) =>
    api.post<EmailTemplateEditor>(
      `/admin/email-templates/${encodeURIComponent(key)}/restore/${versionNumber}`,
    ),

  reset: (key: string) =>
    api.post<EmailTemplateEditor>(`/admin/email-templates/${encodeURIComponent(key)}/reset`),

  preview: (key: string, blocks: EmailTemplatePreviewBlockInput[]) =>
    api.post<EmailTemplatePreview>(
      `/admin/email-templates/${encodeURIComponent(key)}/preview`,
      { blocks },
    ),
};
